export default {
      id: "ic_save-usage",
      viewBox: "0 0 28 28",
      url: "/" + "images/icons.3.109.2.svg#ic_save-usage",
      toString: function () {
        return this.url;
      }
    }